import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanMatch, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AUTH_SERVICE_TOKEN, IAuthService } from '../services/auth/auth-service.interface';

@Injectable()
export class AuthGuard implements CanMatch {
  constructor(
    @Inject(AUTH_SERVICE_TOKEN) private authService: IAuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authService.isAuthorized()) {
      return true;
    }

    // construct full URL with query parameters
    let redirectUrl = state.url;
    const queryParams = route.queryParams;
    if (queryParams && Object.keys(queryParams).length > 0) {
      const queryString = Object.keys(queryParams)
        .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`)
        .join('&');
      redirectUrl = `${state.url}?${queryString}`;
    }

    return this.router.createUrlTree(['/auth/login'], { queryParams: { redirect: redirectUrl } });
  }

  canMatch(): boolean | UrlTree {
    if (this.authService.isAuthorized()) {
      return true;
    }
    // extractedUrl is the URL before redirects (still '/' rather than 'app/dashboard').
    // Login lives at /auth/login and reads queryParams.redirect. /auth/signin does not
    // exist here, so that redirect fell through to ** and grew the URL until
    // encodeURIComponent threw "Invalid string length".
    const extractedUrl = this.router.currentNavigation()?.extractedUrl;
    const redirect = extractedUrl ? this.router.serializeUrl(extractedUrl) : '/';
    return this.router.createUrlTree(['/auth/login'], { queryParams: { redirect } });
  }
}
